<div class="card" >
<div class="card-container">
        <div class="row">
          <div class="col-12" text-center>
            <h4>{{data1}}</h4>
          </div>
          </div>
          <div class="row">
            <div class="col-12 text-center">
            <button class="btn btn-success" (click)="close()">Ok</button>
            </div>
          </div>
      </div>
    </div>